import { useMutation } from "@tanstack/react-query";
import {
  IDownloadLeaveRequestTemplateParams,
  LeaveRequestService,
} from "../../../../../services/vos/leave-request/leave-request.service";

const useDownloadLeaveRequestTemplate = () => {
  const mutation = useMutation<void, unknown, IDownloadLeaveRequestTemplateParams>({
    mutationFn: (params: IDownloadLeaveRequestTemplateParams) =>
      LeaveRequestService.downloadLeaveRequestTemplate(params),
  });

  return mutation;
};

export default useDownloadLeaveRequestTemplate;
